<template>
  <div class="section-title">
    <div class="background-title">{{ title }}</div>
  </div>
</template>

<script>
export default {
  name: "SectionTitle",
  props: {
    title: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped>
.section-title {
  height: 25px;
  margin-bottom: 5px;
}

.background-title {
  text-align: center;
  background: #f49c1a;
  border-radius: 10px 10px 0 0;
  color: white;
  height: 25px;
  font-size: clamp(10px, 2.6vw, 12px);
  line-height: 25px;
}
</style>
